export class LoginResponseDTO {
    access_token: string;
    token_type: string;
    expires_in?: number;
    refresh_token?: string;
}


// WEBPACK FOOTER //
// ./src/app/DTO/loginResponseDTO.ts